import { Shop } from 'types'
import {
    getShopId,
    useQueryHandler,
    usePaginationHandler,
    updateShopId, getUserId,
    useAuthentication,
    updateShopName,
    isLoggedIn
} from 'utils'

const shopQuery = `
    id
    externalId
    name
    image{
        id
        path
    }
    domain
    url
    isMigrated
`
export const useCurrentShop = () => {

    const shopId = getShopId()
    const hasShopId = shopId !== ''

    const { logout } = useAuthentication()

    const removeShop = () => {
        updateShopId(null)
        updateShopName(null)
    }
    
    return useQueryHandler<Shop>({
        query: hasShopId ? `
            query getShop(
                $id: String!
            ){
                getShop(
                    id: $id
                ){
                    ${shopQuery}
                }
            }
        `: `
            query getShops(
                $limit: Int!
            ){
                getShops(
                    limit: $limit
                ){
                    data{
                        ${shopQuery}
                    }
                }
            }
        `,
        variables: hasShopId ? {
            id: shopId
        } : {
            limit: 1
        },
        cacheKey: ['currentShop', shopId, getUserId()],
        enabled: isLoggedIn(),
        onSuccess: json => {
            if(!hasShopId && json.data.getShops.data.length === 0){
                return null
            }
            const shop: Shop = hasShopId ? json.data.getShop : json.data.getShops.data[0]
            if(!hasShopId){
                updateShopId(shop.id)
            }
            updateShopName(shop.name)
            return shop
        },
        onNotFound: removeShop,
        onForbidden: () => {
            if(shopId){
                removeShop()
            }else{
                logout()
            }
        },
        onUnknownError: removeShop
    })

}

export const useShops = (search: string | null, limit: number) => {

    const { logout } = useAuthentication()
    
    return usePaginationHandler<Shop[]>({
        query: `
            query getShops(
                $searchTerm: String,
                $limit: Int!,
                $after: String,
                $before: String
            ){
                getShops(
                    searchTerm: $searchTerm,
                    limit: $limit,
                    after: $after,
                    before: $before
                ){
                    data{
                        ${shopQuery}
                    }
                    totalItems
                    remainingItems
                    nextCursor
                    previousCursor
                }
            }
        `,
        variables: {
            searchTerm: search,
            limit,
            after: null,
            before: null
        },
        cacheKey: ['shops', getUserId()],
        limit,
        getResponse: json => json.data.getShops,
        onSuccess: response => response.data,
        onForbidden: logout
    })
}
